import { Fragment, useEffect, useState } from "react";
import { Breadcrumb, FloatingLabel, Form, Modal, Table } from "react-bootstrap";
import LoadingComponent from "../../widgets/LoadingComponent";
import { getData } from "../../api/ApiRest";
import { formatNumber } from "../../widgets/FormatNumber";
import { Grid, Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { formatDateddMMMyyyy } from "../../widgets/DateTime";

function ProyeccionVentas() {
    const [loading, setLoading] = useState(false);

    const [datos, setDatos] = useState([]);
    const [anios_x, setAniosX] = useState([]);
    const [dataBuscar, setDataBuscar] = useState({
        Tipo: false, Reporte: 'R'
    });

    const [infoModal, setInfoModal] = useState({
        ModalVisible: false, Titulo: '', Tipo: '', Year: '', Datos: []
    });

    const [dataFolios, setDataFolios] = useState([]);
    const [dataCertificado, setDataCertificado] = useState([]);

    const [anioActual, setAnioActual] = useState(null);
    const [anioPosterior, setAnioPosterior] = useState(null);

    const [recibos, setRecibos] = useState([]);
    const [modalRecibos, setModalRecibos] = useState({
        ModalVisible: false, Titulo: '', Mes: '', Year: '', Datos: [], FechaIni: '', FechaFin: ''
    });

    const [detalles, setDetalles] = useState([]);
    const [modalDetalles, setModalDetalles] = useState({
        ModalVisible: false, Titulo: '', Mes: '', Year: '', Datos: []
    });

    const [planesInactivos, setPlanesInactivos] = useState([]);
    const [modalInactivos, setModalInactivos] = useState({
        ModalVisible: false, Titulo: '', Mes: '', Year: '', Datos: [], FechaIni: '', FechaFin: ''
    });

    useEffect(() => {
        const actual = new Date().getFullYear();
        const posterior = actual + 1;

        setAnioActual(actual);
        setAnioPosterior(posterior);

        if (anioActual !== null)
            getDatos('R');
    }, [anioActual])

    // const getDatos = async (Reporte = 'R') => {
    //     setLoading(true);

    //     await getData('api/Configuracion/Reporte/ProyeccionPlanes', {
    //         saldofv: false,
    //         reporte: Reporte
    //     }).then(response => {
    //         setDatos(response.list);
    //         setDataCertificado(response.listCertificates);

    //         const anios = [...new Set(response.list.filter(item => item.year >= 2025).map(x => x.year))];
    //         setAniosX(anios);

    //         setLoading(false);
    //     }, error => {
    //         console.log(error);
    //         setLoading(false);
    //     })
    // }

    const getDatos = async (Reporte = 'R') => {
        setLoading(true);

        await getData('api/Configuracion/Reporte/ProyeccionVentasxConsumo', {
            reporte: Reporte
        }).then(response => {
            setDatos(response.list);
            setDataCertificado(response.listCertificates);
            setDetalles(response.detallado);
            setRecibos(response.recibos);
            setPlanesInactivos(response.planes_inactivos);

            const anios = [...new Set(response.list.filter(item => item.year >= anioActual && item.year <= anioPosterior).map(x => x.year))];
            setAniosX(anios);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Función que me permite visualizar el consumo x folios para renovar
    const getDataFolios = async () => {
        await getData('api/Configuracion/Reporte/ProyeccionVentasxConsumo').then(response => {
            setDataFolios(response.list);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    const Meses = [
        { key: '1', value: 'Enero' },
        { key: '2', value: 'Febrero' },
        { key: '3', value: 'Marzo' },
        { key: '4', value: 'Abril' },
        { key: '5', value: 'Mayo' },
        { key: '6', value: 'Junio' },
        { key: '7', value: 'Julio' },
        { key: '8', value: 'Agosto' },
        { key: '9', value: 'Septiembre' },
        { key: '10', value: 'Octubre' },
        { key: '11', value: 'Noviembre' },
        { key: '12', value: 'Diciembre' }
    ];

    const labels = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
    ];

    function proyeccionesAnuales() {
        const resultado = labels.map((mes, i) => {
            let fila = { Mes: mes };
            anios_x.forEach((anio) => {
                fila[anio] = 0;
            });

            return fila;
        })

        datos.forEach((v) => {
            const medIndex = v.mes - 1;
            resultado[medIndex][v.year] = v.total;
        })

        return resultado;
    }

    const ObtenerFechasDelMes = (mes, anio) => {
        const fechaInicial = new Date(anio, mes - 1, 1);
        const fechaFinal = new Date(anio, mes, 0);

        return {
            fechaIni: fechaInicial.toISOString().split('T')[0],
            fechaFin: fechaFinal.toISOString().split('T')[0] + ' 23:59:59'
        };
    }

    const RecaudoAnual = (mes, anio) => {
        const mesEncontrado = Meses.find(item => item.value === mes);
        if (!mesEncontrado) return 0;

        const mesValor = mesEncontrado.key;
        const { fechaIni, fechaFin } = ObtenerFechasDelMes(mesValor, anio);

        const totalEncontrado = recibos.filter(item =>
            new Date(item.fecha) >= new Date(fechaIni) &&
            new Date(item.fecha) <= new Date(fechaFin)
        );

        return totalEncontrado ? totalEncontrado.reduce((acc, curr) => acc + curr.valor, 0) ?? totalEncontrado : 0;
    }

    const InactivosAnual = (mes, anio) => {
        const mesEncontrado = Meses.find(item => item.value === mes);
        if (!mesEncontrado) return 0;

        const mesValor = mesEncontrado.key;
        const { fechaIni, fechaFin } = ObtenerFechasDelMes(mesValor, anio);

        const totalEncontrado = planesInactivos.filter(item =>
            new Date(item.fincontratado) >= new Date(fechaIni) &&
            new Date(item.fincontratado) <= new Date(fechaFin)
        );

        return totalEncontrado ? totalEncontrado.reduce((acc, curr) => acc + curr.valor, 0) ?? totalEncontrado : 0;
    }

    // const RecaudoAnual = (mes, anio) => {
    //     const mesEncontrado = Meses.find(item => item.value === mes);
    //     if (!mesEncontrado) return 0;

    //     const mesValor = mesEncontrado.key;

    //     const totalEncontrado = datos.find(item =>
    //         Number(item.mes) === Number(mesValor) &&
    //         Number(item.year) === Number(anio)
    //     );

    //     return totalEncontrado ? totalEncontrado.recibido ?? totalEncontrado : 0;
    // }

    return <div className='BodyComponent'>

        {<LoadingComponent Loading={loading} />}

        <div className="row" style={{ marginTop: -20 }}>
            <div className="col-md-3">
                <FloatingLabel
                    controlId='TipoNewInput'
                    label="Tipo"
                    className="form-floating-sm"
                >
                    <Form.Select
                        className="input-fecha-sm"
                        value={dataBuscar.Reporte}
                        onChange={event => {
                            setDataBuscar({ ...dataBuscar, Reporte: event.target.value });

                            getDatos(event.target.value);

                            ///Solamente cuando es detallado procede a cargar la proyección
                            if (event.target.value === "D") {
                                getDataFolios();
                            }
                        }}
                    >
                        <option value="R">Global</option>
                        <option value="D">Detallado</option>
                    </Form.Select>
                </FloatingLabel>
            </div>
        </div>

        {dataBuscar.Reporte === 'R' ? <div className="row">
            <div className='table-responsive mt-2'>
                <table className='table table-borderless table-hover'>
                    <thead>
                        <tr>
                            <th className="estilo-encabezado" rowSpan={2}>
                                Mes
                            </th>
                            {anios_x.map((item, index) => (
                                <th className="estilo-encabezado" key={index} colSpan={4}>{item}</th>
                            ))}
                        </tr>
                        <tr>
                            {anios_x.map((anio, i) => (
                                <Fragment key={`sub-${i}`}>
                                    <th className="estilo-encabezado">Recaudo</th>
                                    <th className="estilo-encabezado">Proyección</th>
                                    <th className="estilo-encabezado">Inactivos</th>
                                    <th className="estilo-encabezado">%</th>
                                </Fragment>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {proyeccionesAnuales().map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td className="text-center" style={{ fontSize: 14 }}>{item.Mes}</td>
                                    {anios_x.map((anio, i) => (
                                        <Fragment key={i}>
                                            <td style={{
                                                textAlign: 'right', fontSize: 14, cursor: "pointer",
                                                color: "#224B6A"
                                            }} onClick={() => {
                                                const mesKey = parseInt(Meses.filter(x => x.value === item.Mes)[0].key);
                                                const fechaIni = new Date(anio, mesKey - 1, 1);
                                                const fechaFin = new Date(anio, mesKey, 0);
                                                setModalRecibos({
                                                    Titulo: 'Recaudado ' + item.Mes + ' del ' + anio,
                                                    ModalVisible: true,
                                                    Mes: mesKey,
                                                    Year: anio,
                                                    Datos: recibos,
                                                    FechaIni: fechaIni.toISOString().split('T')[0],
                                                    FechaFin: fechaFin.toISOString().split('T')[0] + ' 23:59:59'
                                                });
                                            }}>$ {formatNumber(RecaudoAnual(item.Mes, anio))}</td>
                                            <td style={{
                                                textAlign: 'right', fontSize: 14, textDecoration: "underline",
                                                cursor: "pointer",
                                                color: "#224B6A"
                                            }} onClick={() => {
                                                const ordenado = [...detalles].sort((a, b) => {
                                                    const fechaA = formatDateddMMMyyyy(a.finContratadoPlanAnterior) === '31-Dic-1969' ? a.fincontratado : a.finContratadoPlanAnterior;
                                                    const fechaB = formatDateddMMMyyyy(b.finContratadoPlanAnterior) === '31-Dic-1969' ? b.fincontratado : b.finContratadoPlanAnterior;
                                                    return new Date(fechaA) - new Date(fechaB);
                                                });

                                                setModalDetalles({
                                                    Titulo: 'Proyección ' + item.Mes + ' del ' + anio,
                                                    ModalVisible: true,
                                                    Mes: String(Meses.filter(x => x.value === item.Mes)[0].key),
                                                    Year: anio,
                                                    Datos: ordenado
                                                });
                                            }}>$ {formatNumber(item[anio])}</td>
                                            <td style={{
                                                textAlign: 'right', fontSize: 14, cursor: "pointer",
                                                color: "#224B6A"
                                            }} onClick={() => {
                                                const mesKey = parseInt(Meses.filter(x => x.value === item.Mes)[0].key);
                                                const fechaIni = new Date(anio, mesKey - 1, 1);
                                                const fechaFin = new Date(anio, mesKey, 0);
                                                setModalInactivos({
                                                    Titulo: 'Inactivos ' + item.Mes + ' del ' + anio,
                                                    ModalVisible: true,
                                                    Mes: mesKey,
                                                    Year: anio,
                                                    Datos: planesInactivos,
                                                    FechaIni: fechaIni.toISOString().split('T')[0],
                                                    FechaFin: fechaFin.toISOString().split('T')[0] + ' 23:59:59'
                                                });
                                            }}>
                                                $ {formatNumber(InactivosAnual(item.Mes, anio))}
                                            </td>
                                            <td style={{ textAlign: 'right', fontSize: 14 }}>
                                                {formatNumber(RecaudoAnual(item.Mes, anio) === 0 ? 0 : item[anio] === 0 ? 0 : ((RecaudoAnual(item.Mes, anio) - item[anio]) / item[anio]) * 100)} %
                                            </td>
                                        </Fragment>
                                    ))}
                                </tr>
                            )
                        })}
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>Total</th>
                            {anios_x.map((anio, i) => (
                                <Fragment key={i}>
                                    <th style={{ textAlign: 'right' }}>
                                        $ {formatNumber(recibos.filter(item => new Date(item.fecha).getFullYear() === anio).reduce((acc, curr) => acc + curr.valor, 0))}
                                    </th>
                                    <th style={{ textAlign: 'right' }}>
                                        $ {formatNumber(datos.filter(item => item.year === anio).reduce((acc, curr) => acc + curr.total, 0))}
                                    </th>
                                    <th style={{ textAlign: 'right' }}>
                                        $ {formatNumber(planesInactivos.filter(item => new Date(item.fincontratado).getFullYear() === anio).reduce((acc, curr) => acc + curr.valor, 0))}
                                    </th>
                                    <th></th>
                                </Fragment>
                            ))}
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div> : null}

        {dataBuscar.Reporte === 'D' ?
            <Grid container spacing={2} padding={2}>
                <Grid item xs={12} md={4}>
                    <TableContainer
                        component={Paper}
                        sx={{
                            borderRadius: 3,
                            boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                            overflow: "hidden",
                        }}
                    >
                        <Typography
                            variant="h6"
                            sx={{
                                bgcolor: "rgba(34, 75, 106, 1)",
                                color: "white",
                                py: 1,
                                px: 2,
                                fontWeight: "bold",
                            }}
                            style={{ textAlign: 'center' }}
                        >
                            Renovación por fecha venc
                        </Typography>

                        <Table>
                            <TableHead>
                                <TableRow>
                                    {anios_x.map((item, index) => (
                                        <TableCell
                                            key={index}
                                            sx={{
                                                bgcolor: "rgba(144, 203, 216, 1)",
                                                color: "rgba(34, 75, 106, 1)",
                                                fontWeight: "bold",
                                                textAlign: "center",
                                            }}
                                            style={{ backgroundColor: "rgba(144, 203, 216, 1)" }}
                                        >
                                            {item}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                <TableRow hover>
                                    {anios_x.map((x, index) => (
                                        <TableCell
                                            align="center"
                                            sx={{ fontWeight: "bold", color: "rgba(34, 75, 106, 1)", cursor: 'pointer' }}
                                            key={index}
                                            onClick={() => {
                                                setInfoModal({
                                                    ModalVisible: true, Titulo: ('Renovación por fecha de consumo ' + x), Tipo: 'R', Year: x, Datos: datos
                                                });
                                            }}
                                        >
                                            $ {formatNumber(datos.filter(item => item.year === x && item.tipo === 'R').reduce((acc, curr) => acc + curr.total, 0))}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
                <Grid item xs={12} md={4}>
                    <TableContainer
                        component={Paper}
                        sx={{
                            borderRadius: 3,
                            boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                            overflow: "hidden",
                        }}
                    >
                        <Typography
                            variant="h6"
                            sx={{
                                bgcolor: "rgba(34, 75, 106, 1)",
                                color: "white",
                                py: 1,
                                px: 2,
                                fontWeight: "bold",
                            }}
                            style={{ textAlign: 'center' }}
                        >
                            Mensual
                        </Typography>

                        <Table>
                            <TableHead>
                                <TableRow>
                                    {anios_x.map((item, index) => (
                                        <TableCell
                                            key={index}
                                            sx={{
                                                bgcolor: "rgba(144, 203, 216, 1)",
                                                color: "rgba(34, 75, 106, 1)",
                                                fontWeight: "bold",
                                                textAlign: "center",
                                            }}
                                            style={{ backgroundColor: "rgba(144, 203, 216, 1)" }}
                                        >
                                            {item}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                <TableRow hover>
                                    {anios_x.map((x, index) => (
                                        <TableCell
                                            align="center"
                                            sx={{ fontWeight: "bold", color: "rgba(34, 75, 106, 1)", cursor: 'pointer' }}
                                            key={index}
                                            onClick={() => {
                                                setInfoModal({
                                                    ModalVisible: true, Titulo: ('Mensual ' + x), Tipo: 'M', Year: x, Datos: datos
                                                });
                                            }}
                                        >
                                            $ {formatNumber(datos.filter(item => item.year === x && item.tipo === 'M').reduce((acc, curr) => acc + curr.total, 0))}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
                <Grid item xs={12} md={4}>
                    <TableContainer
                        component={Paper}
                        sx={{
                            borderRadius: 3,
                            boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                            overflow: "hidden",
                        }}
                    >
                        <Typography
                            variant="h6"
                            sx={{
                                bgcolor: "rgba(34, 75, 106, 1)",
                                color: "white",
                                py: 1,
                                px: 2,
                                fontWeight: "bold",
                            }}
                            style={{ textAlign: 'center' }}
                        >
                            Certificados por renovar
                        </Typography>

                        <Table>
                            <TableHead>
                                <TableRow>
                                    {anios_x.map((item, index) => (
                                        <TableCell
                                            key={index}
                                            sx={{
                                                bgcolor: "rgba(144, 203, 216, 1)",
                                                color: "rgba(34, 75, 106, 1)",
                                                fontWeight: "bold",
                                                textAlign: "center",
                                            }}
                                            style={{ backgroundColor: "rgba(144, 203, 216, 1)" }}
                                        >
                                            {item}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                <TableRow hover>
                                    {anios_x.map((x, index) => (
                                        <TableCell
                                            align="center"
                                            sx={{ fontWeight: "bold", color: "rgba(34, 75, 106, 1)", cursor: 'pointer' }}
                                            key={index}
                                            onClick={() => {
                                                setInfoModal({
                                                    ModalVisible: true, Titulo: ('Certificado ' + x), Tipo: 'C', Year: x, Datos: dataCertificado
                                                });
                                            }}
                                        >
                                            $ {formatNumber(dataCertificado.filter(item => item.year === x && item.tipo === 'C').reduce((acc, curr) => acc + curr.venta, 0))}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
                {/* <Grid item xs={12} md={4}>
                    <TableContainer
                        component={Paper}
                        sx={{
                            borderRadius: 3,
                            boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                            overflow: "hidden",
                        }}
                    >
                        <Typography
                            variant="h6"
                            sx={{
                                bgcolor: "rgba(34, 75, 106, 1)",
                                color: "white",
                                py: 1,
                                px: 2,
                                fontWeight: "bold",
                            }}
                            style={{ textAlign: 'center' }}
                        >
                            Renovación por folios
                        </Typography>

                        <Table>
                            <TableHead>
                                <TableRow>
                                    {anios_x.map((item, index) => (
                                        <TableCell
                                            key={index}
                                            sx={{
                                                bgcolor: "rgba(144, 203, 216, 1)",
                                                color: "rgba(34, 75, 106, 1)",
                                                fontWeight: "bold",
                                                textAlign: "center",
                                            }}
                                            style={{ backgroundColor: "rgba(144, 203, 216, 1)" }}
                                        >
                                            {item}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                <TableRow hover>
                                    {anios_x.map((x, index) => (
                                        <TableCell
                                            align="center"
                                            sx={{ fontWeight: "bold", color: "rgba(34, 75, 106, 1)", cursor: 'pointer' }}
                                            key={index}
                                            onClick={() => {
                                                setInfoModal({
                                                    ModalVisible: true, Titulo: ('Renovación x folios ' + x), Tipo: 'R', Year: x, Datos: dataFolios
                                                });
                                            }}
                                        >
                                            $ {formatNumber(dataFolios.filter(item => item.year === x && item.tipo === 'R').reduce((acc, curr) => acc + curr.total, 0))}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid> */}
            </Grid>
            : null}

        <Modal
            show={infoModal.ModalVisible}
            size="xl"
            onHide={() => {
                setInfoModal({
                    ModalVisible: false, Titulo: '', Tipo: '', Year: '', Datos: []
                });
            }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{infoModal.Titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className='table-responsive mt-2'>
                        <table className='table table-borderless table-hover'>
                            <thead>
                                <tr>
                                    <th className="estilo-encabezado">
                                        Mes
                                    </th>
                                    {infoModal.Tipo === 'C' ?
                                        <th className="estilo-encabezado">
                                            Cantidad
                                        </th>
                                        : null}
                                    {infoModal.Tipo === 'C' ?
                                        <th className="estilo-encabezado">
                                            Costo
                                        </th>
                                        : null}
                                    <th className="estilo-encabezado">
                                        Total
                                    </th>
                                    {infoModal.Tipo === 'C' ?
                                        <th className="estilo-encabezado">
                                            Utilidad
                                        </th>
                                        : null}
                                </tr>
                            </thead>
                            <tbody>
                                {infoModal.Datos.filter(item => item.year === infoModal.Year && item.tipo === infoModal.Tipo).map((item, index) => (
                                    <tr key={index}>
                                        <td style={{ textAlign: 'center' }}>{Meses.filter(c => Number(c.key) === item.mes)[0].value}</td>
                                        {infoModal.Tipo === 'C' ?
                                            <td style={{ textAlign: 'center' }}>{formatNumber(item.cantidad)}</td>
                                            : null}
                                        {infoModal.Tipo === 'C' ?
                                            <td style={{ textAlign: 'right' }}>$ {formatNumber(item.costo)}</td>
                                            : null}
                                        <td style={{ textAlign: 'right' }}>$ {infoModal.Tipo === 'C' ? formatNumber(item.venta) : formatNumber(item.total)}</td>
                                        {infoModal.Tipo === 'C' ?
                                            <td style={{ textAlign: 'right' }}>$ {formatNumber(item.venta - item.costo)}</td>
                                            : null}
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th style={{ textAlign: 'center' }}>Total</th>
                                    {infoModal.Tipo === 'C' ?
                                        <th style={{ textAlign: 'center' }}>
                                            {formatNumber(infoModal.Datos.filter(item => item.year === infoModal.Year && item.tipo === infoModal.Tipo).reduce((acc, curr) => acc + curr.cantidad, 0))}
                                        </th>
                                        : null}
                                    {infoModal.Tipo === 'C' ?
                                        <th style={{ textAlign: 'right' }}>
                                            $ {formatNumber(infoModal.Datos.filter(item => item.year === infoModal.Year && item.tipo === infoModal.Tipo).reduce((acc, curr) => acc + curr.costo, 0))}
                                        </th>
                                        : null}
                                    <th style={{ textAlign: 'right' }}>
                                        $ {formatNumber(infoModal.Datos.filter(item => item.year === infoModal.Year && item.tipo === infoModal.Tipo).reduce((acc, curr) => acc + (infoModal.Tipo === 'C' ? curr.venta : curr.total), 0))}
                                    </th>
                                    {infoModal.Tipo === 'C' ?
                                        <th style={{ textAlign: 'right' }}>
                                            $ {formatNumber(infoModal.Datos.filter(item => item.year === infoModal.Year && item.tipo === infoModal.Tipo).reduce((acc, curr) => acc + (curr.venta - curr.costo), 0))}
                                        </th>
                                        : null}
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </Modal.Body>
        </Modal>

        <Modal
            show={modalDetalles.ModalVisible}
            size="xl"
            onHide={() => {
                setModalDetalles({
                    ModalVisible: false, Titulo: '', Mes: '', Year: '', Datos: []
                });
            }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{modalDetalles.Titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className='table-responsive mt-2'>
                        <table className='table table-borderless table-hover'>
                            <thead>
                                <tr>
                                    <th className="estilo-encabezado">
                                        #
                                    </th>
                                    <th className="estilo-encabezado">
                                        Tercero
                                    </th>
                                    <th className="estilo-encabezado">
                                        Factura
                                    </th>
                                    <th className="estilo-encabezado">
                                        Vencimiento
                                    </th>
                                    <th className="estilo-encabezado">
                                        Monto
                                    </th>
                                    <th className="estilo-encabezado">
                                        Tipo
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {modalDetalles.Datos.filter(item => String(item.year) === String(modalDetalles.Year) && String(item.mes) === String(modalDetalles.Mes)).map((item, index) => (
                                    <tr key={index}>
                                        <td style={{ textAlign: 'center', fontSize: '12px' }}>{index + 1}</td>
                                        <td style={{ textAlign: 'center', fontSize: '12px' }}>{item.nit} - {item.nombre_cliente}</td>
                                        <td style={{ textAlign: 'center', fontSize: '12px' }}>{item.factura}</td>
                                        <td style={{ textAlign: 'center', fontSize: '12px' }}>{formatDateddMMMyyyy(item.finContratadoPlanAnterior) === '31-Dic-1969' ? formatDateddMMMyyyy(item.fincontratado) : formatDateddMMMyyyy(item.finContratadoPlanAnterior)}</td>
                                        <td style={{ textAlign: 'right', fontSize: '12px' }}>$ {formatNumber(item.total)}</td>
                                        <td style={{ fontSize: '12px' }}>{item.accion}</td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th></th>
                                    <th style={{ textAlign: 'center' }}>Total</th>
                                    <th></th>
                                    <th></th>
                                    <th style={{ textAlign: 'right', fontSize: '12px' }}>
                                        $ {formatNumber(modalDetalles.Datos.filter(item => String(item.year) === String(modalDetalles.Year) && String(item.mes) === String(modalDetalles.Mes)).reduce((acc, curr) => acc + curr.total, 0))}
                                    </th>
                                    <th></th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </Modal.Body>
        </Modal>

        <Modal
            show={modalRecibos.ModalVisible}
            size="xl"
            onHide={() => {
                setModalRecibos({
                    ModalVisible: false, Titulo: '', Mes: '', Year: '', Datos: [], FechaIni: '', FechaFin: ''
                });
            }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{modalRecibos.Titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className='table-responsive mt-2'>
                        <table className='table table-borderless table-hover'>
                            <thead>
                                <tr>
                                    <th className="estilo-encabezado">
                                        #
                                    </th>
                                    <th className="estilo-encabezado">
                                        Tercero
                                    </th>
                                    <th className="estilo-encabezado">
                                        Documento
                                    </th>
                                    <th className="estilo-encabezado">
                                        Fecha
                                    </th>
                                    <th className="estilo-encabezado">
                                        Monto
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {modalRecibos.Datos.filter(item => new Date(item.fecha) >= new Date(modalRecibos.FechaIni) && new Date(item.fecha) <= new Date(modalRecibos.FechaFin)).map((item, index) => (
                                    <tr key={index}>
                                        <td style={{ textAlign: 'center', fontSize: '12px' }}>{index + 1}</td>
                                        <td style={{ textAlign: 'center', fontSize: '12px' }}>{item.identification_number} - {item.nombre_alterno}</td>
                                        <td style={{ textAlign: 'center', fontSize: '12px' }}>{item.prefijo} - {item.numero}</td>
                                        <td style={{ textAlign: 'center', fontSize: '12px' }}>{formatDateddMMMyyyy(item.fecha)}</td>
                                        <td style={{ textAlign: 'right', fontSize: '12px' }}>$ {formatNumber(item.valor)}</td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th></th>
                                    <th style={{ textAlign: 'center' }}>Total</th>
                                    <th></th>
                                    <th></th>
                                    <th style={{ textAlign: 'right' }}>
                                        $ {formatNumber(modalRecibos.Datos.filter(item => new Date(item.fecha) >= new Date(modalRecibos.FechaIni) && new Date(item.fecha) <= new Date(modalRecibos.FechaFin)).reduce((acc, curr) => acc + curr.valor, 0))}
                                    </th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </Modal.Body>
        </Modal>

        <Modal
            show={modalInactivos.ModalVisible}
            size="xl"
            onHide={() => {
                setModalInactivos({
                    ModalVisible: false, Titulo: '', Mes: '', Year: '', Datos: [], FechaIni: '', FechaFin: ''
                });
            }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>{modalInactivos.Titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className='table-responsive mt-2'>
                        <table className='table table-borderless table-hover'>
                            <thead>
                                <tr>
                                    <th className="estilo-encabezado">
                                        #
                                    </th>
                                    <th className="estilo-encabezado">
                                        Tercero
                                    </th>
                                    <th className="estilo-encabezado">
                                        Plan
                                    </th>
                                    <th className="estilo-encabezado">
                                        Fecha
                                    </th>
                                    <th className="estilo-encabezado">
                                        Valor
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {modalInactivos.Datos.filter(item => new Date(item.fincontratado) >= new Date(modalInactivos.FechaIni) && new Date(item.fincontratado) <= new Date(modalInactivos.FechaFin)).map((item, index) => (
                                    <tr key={index}>
                                        <td style={{ textAlign: 'center', fontSize: '12px' }}>{index + 1}</td>
                                        <td style={{ textAlign: 'center', fontSize: '12px' }}>{item.identification_number} - {item.nombre_alterno}</td>
                                        <td style={{ textAlign: 'center', fontSize: '12px' }}>{item.plan}</td>
                                        <td style={{ textAlign: 'center', fontSize: '12px' }}>{formatDateddMMMyyyy(item.fincontratado)}</td>
                                        <td style={{ textAlign: 'right', fontSize: '12px' }}>$ {formatNumber(item.valor)}</td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th></th>
                                    <th style={{ textAlign: 'center' }}>Total</th>
                                    <th></th>
                                    <th></th>
                                    <th style={{ textAlign: 'right' }}>
                                        $ {formatNumber(modalInactivos.Datos.filter(item => new Date(item.fincontratado) >= new Date(modalInactivos.FechaIni) && new Date(item.fincontratado) <= new Date(modalInactivos.FechaFin)).reduce((acc, curr) => acc + curr.valor, 0))}
                                    </th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    </div>
}

export default ProyeccionVentas;